/** @jsx jsx */
import { css as emotionCss, jsx } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';

const styles = {
  svg: emotionCss`
    display: block;
  `,
};

type Props = {
  width?: number;
  height?: number;
  css?: SerializedStyles;
};

const DefaultHeroImageSvg = ({ width = 566, height = 465, css }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 555 465"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      css={[styles.svg, css]}
    >
      <g clipPath="url(#clip0_71_7886)">
        <path
          d="M219.118 125.669L163.127 0.0637756C49.9173 50.5296 -15.5504 170.484 3.25344 292.998C22.0573 415.512 120.486 510.312 243.619 524.503C366.753 538.695 484.165 468.77 530.345 353.745L402.727 302.509C379.637 360.022 320.931 394.984 259.364 387.889C197.797 380.793 148.583 333.393 139.181 272.136C129.779 210.879 162.513 150.901 219.118 125.669Z"
          fill="var(--cds-color-emphasis-primary-background-weak)"
        />
        <path
          opacity="0.4"
          d="M337.468 349.31C287.451 377.756 224.661 369.445 183.769 329.079L94.9716 417.654C175.782 498.037 300.323 514.721 399.472 458.332C498.621 401.942 547.945 286.374 520.168 175.83L398.648 206.87C412.438 262.649 387.485 320.863 337.468 349.31ZM338.139 347.77C387.273 319.142 411.537 261.348 397.438 206.146L520.894 174.612L521.546 177.221C548.327 286.834 499.793 401.054 402.298 457.86L399.967 459.201C300.136 515.978 174.662 498.966 93.5546 417.655L183.767 327.668C224.321 368.323 287.058 376.829 336.973 348.441L338.139 347.77Z"
          fill="var(--cds-color-emphasis-neutral-background-default)"
        />
      </g>
      <defs>
        <clipPath id="clip0_71_7886">
          <rect width="555" height="465" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DefaultHeroImageSvg;
